export interface CommercialConsumerData {
    clientId: string;
    authToken: string;
    environment?: EnvironmentConfig;
    uniqueIdentifier?: string;
}

export interface EnvironmentConfig {
    EXPERIENCE_API: {
        ENDPOINT: string;
    };
    BILLING: {
        FLEX_REGION: string;
        BC_REGION: string;
    };
}

export const environmentDefaultConfig: EnvironmentConfig = {
    EXPERIENCE_API: {
        ENDPOINT: 'https://api-test.nwie.net/payment-management/commercial-lines-billing/v1/'
    },
    BILLING: {
        FLEX_REGION: '.U080',
        BC_REGION: 'QA'
    }
};
